import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';

/**
 * Wrapper component that reveals children with animation on scroll.
 *
 * @param {string} animation - 'fade-up' | 'fade-in' | 'fade-left' | 'fade-right' | 'scale-in'
 * @param {number} delay - Delay in ms
 * @param {number} threshold - Intersection threshold (0-1)
 */
function ScrollReveal({ children, animation = 'fade-up', delay = 0, threshold = 0.15, className = '', style = {} }) {
    const [ref, isVisible] = useScrollReveal({ threshold, delay });

    return (
        <div
            ref={ref}
            className={`scroll-reveal scroll-${animation} ${isVisible ? 'scroll-visible' : ''} ${className}`}
            style={style}
        >
            {children}
        </div>
    );
}

export default ScrollReveal;
